import { makeStyles } from '@mui/styles';

export const systemItemModalsStyles = makeStyles(() => ({}));
